import { ProductColor, TypographyVariant } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { Td } from '../../summary/components/Td.tsx';
import { Typography } from '../../summary/components/Typography.tsx';
import { ValueFormatter } from './types.ts';
import { formatValueForCell } from './utils/formatValueForCell.ts';

type SummaryTableHorizontalCellProps = {
  isFirstRow?: boolean;
  isFirstColumn?: boolean;
  rowSpan?: number;
  cellValue?: unknown;
  valueFormatter?: ValueFormatter;
  cellBackgroundColor?: { backgroundColor?: ProductColor };
  typographyVariant?: TypographyVariant;
};

export const SummaryTableHorizontalCell = ({
  isFirstRow = false,
  isFirstColumn = false,
  rowSpan = 1,
  cellValue,
  valueFormatter,
  cellBackgroundColor = {},
  typographyVariant = 'body2',
  children,
}: PropsWithChildren<SummaryTableHorizontalCellProps>) => {
  const { str, color } = formatValueForCell(cellValue, valueFormatter);

  return (
    <Td
      isFirstRow={isFirstRow}
      isFirstColumn={isFirstColumn}
      rowSpan={rowSpan}
      {...cellBackgroundColor}
    >
      {str.map((string, idx) => (
        <Typography key={idx} variant={typographyVariant} color={color}>
          {string}
        </Typography>
      ))}
      {children}
    </Td>
  );
};
